var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightRodLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M13.89,18.97L6.59,19L9.75,7.06c0.11,0.01,0.22,0.02,0.33,0.02c0.12,0,0.24-0.01,0.36-0.03l3.27,11.28L13.89,18.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M7.88,4.89c0,0.51,0.17,0.97,0.46,1.34h-7.5V3.55h7.49C8.05,3.92,7.88,4.38,7.88,4.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M15.293,3.55v2.68H11.81c0.252-0.37,0.401-0.83,0.401-1.34c0-0.51-0.148-0.97-0.401-1.34H15.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M12.27,4.89c0,0.51-0.17,0.97-0.46,1.34C11.48,6.66,11,6.96,10.44,7.05c-0.12,0.02-0.24,0.03-0.36,0.03 c-0.11,0-0.22-0.01-0.33-0.02C9.18,6.97,8.68,6.67,8.34,6.23C8.05,5.86,7.88,5.4,7.88,4.89c0-0.51,0.17-0.97,0.45-1.34 c0.41-0.53,1.04-0.86,1.75-0.86c0.71,0,1.34,0.33,1.73,0.86C12.1,3.92,12.27,4.38,12.27,4.89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 2.309,18.493 4.662,18.493 4.662,13.251 3.485,13.251 2.309,13.251  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 3.485,
    y1: 6.559,
    x2: 3.485,
    y2: 12.87
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 19.149,
    y1: 19.107,
    x2: 0.837,
    y2: 19.107
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 11.387,
    y1: 11.22,
    x2: 8.324,
    y2: 13.279
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 8.399,
    y1: 14.19,
    x2: 14.376,
    y2: 18.861
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: " M15.4,3.55v2.68"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    d: " M15.293,3.76V1.245c0-0.246,0.213-0.435,0.471-0.435c1.867,0,3.383,1.39,3.383,3.11v2.505c0,1.702-1.516,3.11-3.383,3.11 c-0.259,0-0.471-0.199-0.471-0.444V6.293V3.76z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRodLift);
export default __webpack_public_path__ + "static/media/light-rod-lift.b3f24e2ab20b949603f2ddf98a185076.svg";
export { ForwardRef as ReactComponent };